import { render, staticRenderFns } from "./signing-configuration.vue?vue&type=template&id=4674126c&scoped=true&"
import script from "./signing-configuration.vue?vue&type=script&lang=js&"
export * from "./signing-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674126c",
  null
  
)

export default component.exports